import { readBookInfo } from "./book-info.js";
import { optionsFromElement } from "./viewer-options.js";
import Viewer from "./Viewer.js";

// The Drupal library is only attached when a viewer is rendered. Keeping the
// implementation in the same module graph avoids a dynamic chunk importing
// the cache-busted entry point a second time under a different URL.
const defaultLoadViewer = async () => ({ default: Viewer });

export async function initializeBook(
  element,
  Viewer,
  documentRoot = document,
  i18n = {},
) {
  if (element.rhea) return element.rhea;

  const viewer = new Viewer(
    element,
    await readBookInfo(element, documentRoot),
    { ...optionsFromElement(element), i18n },
  );
  element.rhea = viewer;

  return viewer;
}

export async function initializeBooks({
  documentRoot = document,
  elements = [...documentRoot.querySelectorAll(".rhea-book-viewer")],
  loadViewer = defaultLoadViewer,
  logger = console,
  i18n = {},
} = {}) {
  if (elements.length === 0) return [];

  let Viewer;
  try {
    ({ default: Viewer } = await loadViewer());
  } catch (error) {
    logger.error("RheaBookLoader: could not load the viewer module.", error);
    return [];
  }

  const viewers = [];
  for (const element of elements) {
    try {
      viewers.push(await initializeBook(element, Viewer, documentRoot, i18n));
    } catch (error) {
      logger.error(
        `RheaBookLoader: could not initialize book "${element.id || "unknown"}".`,
        error,
      );
    }
  }

  return viewers;
}
